module.exports = __webpack_public_path__ + "android-icon-72x72.png?f1e2b9c7acfb75397a4ed1db5ea07344";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-icon-72x72.png
// module id = 125
// module chunks = 0